export var units;
(function (units) {
    units["Piece"] = "st";
    units["SquareMeter"] = "m2";
    units["Lpm"] = "lpm";
    units["Omg"] = "omg.";
    units["Kilo"] = "kg";
    units["Ton"] = "ton";
    units["CubicMeter"] = "m3";
    units["Hour"] = "h";
})(units || (units = {}));
